import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 10px;

  width: 50%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  grid-area: ${({ gridArea }) => gridArea};

  ${media.lessThan("medium")`
    width: 100%;
  `}
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  ${media.lessThan("medium")`
    align-items: flex-start;
    flex-direction: column;

    width: 100%;
  `}
`;

export const To = styled.span`
  padding-top: ${({ hasLabel }) => (hasLabel ? "20px" : "0")};

  ${media.lessThan("medium")`
    display: none;
  `}
`;
